export default "__VITE_ASSET__fd6950dc__"